import { CardContent, Divider, Stack, type SxProps } from '@mui/material';
import { useState, type PropsWithChildren } from 'react';
import { WizardStepper } from './wizardStepper';
import { PanelFooter } from '../panels/panelFooter';
type StepContainerProps = PropsWithChildren<{
  onBackClick?: () => void;
  onNextClick: () => Promise<void>;
  canGoNext: () => boolean;
  nextButtonText?: string;
  nextButtonDisabledTooltip?: string;
  nextButtonLoadingText?: string;
  backButtonText?: string;
  hideNavigation?: false;
  hideStepper?: boolean;
  stepperLabels?: string[];
  stepperIndex?: number;
  sx?: SxProps;
  navigationComponent?: React.ReactNode;
  toolbarComponent?: React.ReactNode;
}> | PropsWithChildren<{
  hideNavigation: true;
  hideStepper?: boolean;
  stepperLabels?: string[];
  stepperIndex: number;
  sx?: SxProps;
  toolbarComponent?: React.ReactNode;
  nextButtonLoadingText?: string;
}>;
export const StepContainer = (props: StepContainerProps) => {
  const [nextInProgress, setNextInProgress] = useState(false);
  const handleNextClick = async () => {
    if ('onNextClick' in props && props.onNextClick) {
      setNextInProgress(true);
      try {
        await props.onNextClick();
      } finally {
        setNextInProgress(false);
      }
    }
  };
  return <Stack className='h-full'>
      <Stack className='overflow-y-auto' sx={{
      flexGrow: 1
    }}>
        <Stack sx={{
        gap: '12px'
      }}>
          {props.toolbarComponent}
          {!props.hideStepper ? <Stack>
              <WizardStepper activeStep={props.stepperIndex ?? 0} stepsLabels={props.stepperLabels ?? []} />
              <Divider />
            </Stack> : props.toolbarComponent && <Divider className='mt-[12px]' />}
        </Stack>
        <CardContent className='grow flex flex-col' sx={{
        padding: '40px',
        ...props.sx
      }}>
          {props.children}
        </CardContent>
      </Stack>
      {!props.hideNavigation && <PanelFooter submitInProgress={nextInProgress} loadingText={props.nextButtonLoadingText} primaryButton={{
      text: props.nextButtonText || 'Next',
      onClick: handleNextClick,
      disabled: !props.canGoNext(),
      disabledTooltip: props.nextButtonDisabledTooltip,
      'data-testid': 'wizard-step-next-btn'
    }} secondaryButton={props.onBackClick ? {
      text: props.backButtonText || 'Back',
      onClick: props.onBackClick,
      'data-testid': 'wizard-step-back-btn'
    } : undefined}>
          {props.navigationComponent}
        </PanelFooter>}
    </Stack>;
};